var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#D12600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 23,
    width: 30,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1045 40.9441L34.7311 48.3308C33.9578 49.1175 32.7045 49.1175 31.9178 48.3442C31.4378 47.8642 31.2378 47.1841 31.3711 46.5175L32.6378 40.4108H25.1045C22.2378 40.4108 20.3045 37.4775 21.4378 34.8375L25.7845 24.6908C26.1978 23.7175 27.1578 23.0775 28.2245 23.0775H40.2111C41.6778 23.0775 42.8778 24.2775 42.8778 25.7442V39.0641C42.8778 39.7708 42.5978 40.4508 42.1045 40.9441ZM45.5578 25.7442C45.5578 24.2775 46.7578 23.0775 48.2245 23.0775C49.6911 23.0775 50.8911 24.2775 50.8911 25.7442V36.4108C50.8911 37.8775 49.6911 39.0775 48.2245 39.0775C46.7578 39.0775 45.5578 37.8775 45.5578 36.4108V25.7442Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 32,
    height: 32,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativo);
export default __webpack_public_path__ + "static/media/Negativo.baa3a614561dc343c1772efbe2e2e99e.svg";
export { ForwardRef as ReactComponent };